import { FunctionalComponent, h } from "preact";

interface FeedbackTextProps {
  isPositive: boolean;
}

export const FeedbackText: FunctionalComponent<FeedbackTextProps> = ({ isPositive }: FeedbackTextProps) => {
  if (isPositive) {
    return (
      <p>
        Så bra! Takk for at du deler - vi elsker gode nyheter!
        <br />
        Vi vil alltid bli enda bedre, så har du noen tanker eller ønsker, del dem gjerne i feltet nedenfor.
      </p>
    );
  }

  return (
    <p>
      Uff da! Det var ikke helt meningen.
      <br />
      Vi vil gjerne fikse dette - hva kan vi gjøre annerledes? Fortell oss i feltet nedenfor, så tar vi det med oss
      videre!
    </p>
  );
};
